import teamGroupStyles from "../../styles/ganttChart/teamgroups.module.css";
import { TeamGroupColorMaps } from "../../utils/TeamColorGroupUtils";

const EmployeeTeamsComponent = ({
  teamGroupColorMaps,
  columnWidth,
  leftOffset,
}: {
  teamGroupColorMaps: TeamGroupColorMaps;
  columnWidth: number;
  leftOffset: number;
}) => {
  const { colorGroupCounts, colorGroupToTeamNumberMap } = teamGroupColorMaps;

  function getLuminance(hex: string) {
    const rgb = [0, 2, 4].map((i) => {
      const c = parseInt(hex.slice(1 + i, 3 + i), 16) / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
  }

  function getContrastColor(hex: string) {
    return getLuminance(hex) > 0.179 ? "#000000" : "#FFFFFF";
  }

  return (
    <div
      className={teamGroupStyles.teamgroupContainer}
      style={{ paddingLeft: leftOffset }}
    >
      {Array.from(colorGroupToTeamNumberMap.entries()).map(
        ([colorGroup, teamName]) => (
          <div
            key={teamName}
            className={teamGroupStyles.teamgroupTeamWrapper}
            style={{
              width: colorGroupCounts[colorGroup] * columnWidth,
              marginLeft: "-1px",
            }}
          >
            <div
              className={teamGroupStyles.teamgroupChip}
              style={{
                backgroundColor: colorGroupToTeamNumberMap.get(colorGroup),
              }}
            >
              <p
                className={teamGroupStyles.teamgroupTeamTitle}
                style={{
                  color: getContrastColor(
                    colorGroupToTeamNumberMap.get(colorGroup)!,
                  ),
                }}
              >
                {teamName}
              </p>
            </div>
          </div>
        ),
      )}
    </div>
  );
};

export default EmployeeTeamsComponent;
